<template>
<div class="chapter">
<div class="inner_page">
<div id="toc">
<h1 id="toc-title">Another Adventure for Des Pond, Special Agent</h1>
<ol class="toc">
<li id="toc-li-1"><a href="#/text/ch001#about-the-author">About the Author</a></li>
<li id="toc-li-2"><a href="#/text/ch002#copyright-information">Copyright Information ©</a></li>
<li id="toc-li-3"><a href="#/text/ch003#chapter-1-bird-watching">Chapter 1: Bird Watching?</a></li>
<li id="toc-li-4"><a href="#/text/ch004#chapter-2-the-meeting-of-agents">Chapter 2: The Meeting of Agents</a>
</li>
<li id="toc-li-5"><a href="#/text/ch005#chapter-3-in-foreign-lands-afar">Chapter 3: In Foreign Lands Afar</a>
</li>
<li id="toc-li-6"><a href="#/text/ch006#chapter-4-hardly-a-navy">Chapter 4: Hardly a Navy</a></li>
<li id="toc-li-7"><span href="#/text/ch007#chapter-5-there-must-be-some-other-country-involved." title="Link target outside of Sample">Chapter 5:
                ‘There Must Be Some Other Country Involved.’</span></li>
<li id="toc-li-8"><span href="#/text/ch008#chapter-6-10-downing-st-london" title="Link target outside of Sample">Chapter 6: 10, Downing St London</span>
</li>
<li id="toc-li-9"><span href="#/text/ch009#chapter-7-headquarters-of-mi5-london" title="Link target outside of Sample">Chapter 7: Headquarters of MI5,
                London</span></li>
<li id="toc-li-10"><span href="#/text/ch010#chapter-8-10-downing-st-london" title="Link target outside of Sample">Chapter 8: 10, Downing St London</span>
</li>
<li id="toc-li-11"><span href="#/text/ch011#chapter-9-somewhere-in-belarania" title="Link target outside of Sample">Chapter 9: Somewhere in
                Belarania</span></li>
<li id="toc-li-12"><span href="#/text/ch012#chapter-10-10-downing-st-london" title="Link target outside of Sample">Chapter 10: 10, Downing St
                London</span></li>
<li id="toc-li-13"><span href="#/text/ch013#chapter-11-the-thames-flood-barrier-near-greenwich" title="Link target outside of Sample">Chapter 11: The
                Thames Flood Barrier near Greenwich</span></li>
<li id="toc-li-14"><span href="#/text/ch014#chapter-12-10-downing-st-london" title="Link target outside of Sample">Chapter 12: 10, Downing St
                London</span></li>
<li id="toc-li-15"><span href="#/text/ch015#chapter-13-pond-ponders-the-problem" title="Link target outside of Sample">Chapter 13: Pond Ponders the
                Problem</span></li>
<li id="toc-li-16"><span href="#/text/ch016#chapter-14-10-downing-st-london" title="Link target outside of Sample">Chapter 14: 10, Downing St
                London</span></li>
<li id="toc-li-17"><span href="#/text/ch017#chapter-15-pond-receives-a-telephone-call" title="Link target outside of Sample">Chapter 15: Pond Receives
                a Telephone Call</span></li>
<li id="toc-li-18"><span href="#/text/ch018#chapter-16-10-downing-st-london" title="Link target outside of Sample">Chapter 16: 10, Downing St
                London</span></li>
<li id="toc-li-19"><span href="#/text/ch019#chapter-17-dont-panic" title="Link target outside of Sample">Chapter 17: Don’t Panic!</span></li>
<li id="toc-li-20"><span href="#/text/ch020#chapter-18-all-are-in-despond" title="Link target outside of Sample">Chapter 18: All Are in Despond</span>
</li>
<li id="toc-li-21"><span href="#/text/ch021#chapter-19-row-row-row-your-boat" title="Link target outside of Sample">Chapter 19: Row, Row, Row Your
                Boat</span></li>
<li id="toc-li-22"><span href="#/text/ch022#chapter-20-stand-by-chaps" title="Link target outside of Sample">Chapter 20: ‘Stand By, Chaps!’</span></li>
<li id="toc-li-23"><span href="#/text/ch023#chapter-21-the-war-cabinet-meets" title="Link target outside of Sample">Chapter 21: The War Cabinet
                Meets</span></li>
<li id="toc-li-24"><span href="#/text/ch024#chapter-22-the-negotiations-begin" title="Link target outside of Sample">Chapter 22: The Negotiations
                Begin</span></li>
<li id="toc-li-25"><span href="#/text/ch025#chapter-23-diplomacy-the-pond-way" title="Link target outside of Sample">Chapter 23: Diplomacy, the Pond
                Way</span></li>
<li id="toc-li-26"><span href="#/text/ch026#chapter-24-will-the-enemy-back-down" title="Link target outside of Sample">Chapter 24: Will the Enemy Back
                Down?</span></li>
<li id="toc-li-27"><span href="#/text/ch027#chapter-25-10-downing-st-london" title="Link target outside of Sample">Chapter 25: 10, Downing St
                London</span></li>
<li id="toc-li-28"><span href="#/text/ch028#chapter-26-a-very-remote-hideaway-in-pandamia" title="Link target outside of Sample">Chapter 26: A Very
                Remote Hideaway in Pandamia</span></li>
<li id="toc-li-29"><span href="#/text/ch029#chapter-27-hot-on-the-trail" title="Link target outside of Sample">Chapter 27: Hot on the Trail</span></li>
<li id="toc-li-30"><span href="#/text/ch030#chapter-28-patience-is-a-virtue" title="Link target outside of Sample">Chapter 28: Patience Is a
                Virtue!</span></li>
<li id="toc-li-31"><span href="#/text/ch031#chapter-29-iron-bars-do-not-a-prison-make." title="Link target outside of Sample">Chapter 29: ‘Iron Bars
                Do Not a Prison Make.’</span></li>
<li id="toc-li-32"><span href="#/text/ch032#chapter-30-will-the-cavalry-arrive-in-the-nick-of-time" title="Link target outside of Sample">Chapter 30:
                Will the Cavalry Arrive in the Nick of Time?</span></li>
<li id="toc-li-33"><span href="#/text/ch033#chapter-31-10-downing-st-london" title="Link target outside of Sample">Chapter 31: 10, Downing St
                London</span></li>
<li id="toc-li-34"><span href="#/text/ch034#chapter-32-pond-is-bored-waiting" title="Link target outside of Sample">Chapter 32: Pond Is Bored
                Waiting</span></li>
<li id="toc-li-35"><span href="#/text/ch035#chapter-33-pond-in-despond" title="Link target outside of Sample">Chapter 33: Pond in Despond</span></li>
<li id="toc-li-36"><span href="#/text/ch036#chapter-34-someone-blunders" title="Link target outside of Sample">Chapter 34: Someone Blunders</span></li>
<li id="toc-li-37"><span href="#/text/ch037#chapter-35-10-downing-st-london" title="Link target outside of Sample">Chapter 35: 10, Downing St
                London</span></li>
<li id="toc-li-38"><span href="#/text/ch038#chapter-36-the-prime-ministers-office" title="Link target outside of Sample">Chapter 36: The Prime
                Minister’s Office</span></li>
</ol>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// nav.vue?1ed91ffe